<template>
  <div id="menuContainer" :style="hideStyle">
    <div id="toolboxGrabber" @click="toggleShowAnnotationMenu">
      <i v-if="$store.state.showAnnotationMenu" class="fas fa-angle-double-right"></i>
      <i v-else class="fas fa-angle-double-left"></i>
    </div>

    <div id="backgroundWrapper">
      <!-- <div id="annotationMenu">
        <h4>Annotations</h4>
        <div class="annotationButtons">
          <img :class="currentMode === 'text' ? 'active' : ''" draggable="false" src="static/text.svg" @click="annotationMode('text')">
          <img :class="currentMode === 'highlighter' ? 'active' : ''" draggable="false" src="static/highlighter.svg" @click="annotationMode('highlighter')">
          <img :class="currentMode === 'arrow-standard' ? 'active' : ''" draggable="false" src="static/arrow-standard.svg" @click="annotationMode('arrow-standard')">
          <img :class="currentMode === 'arrow-thick' ? 'active' : ''" draggable="false" src="static/arrow-thick.svg" @click="annotationMode('arrow-thick')">
          <img :class="currentMode === 'arrow-thin' ? 'active' : ''" draggable="false" src="static/arrow-thin.svg" @click="annotationMode('arrow-thin')">
          <img :class="currentMode === 'hand-point' ? 'active' : ''" draggable="false" src="static/hand-point.svg" @click="annotationMode('hand-point')">
          <img :class="currentMode === 'hand-good' ? 'active' : ''" draggable="false" src="static/hand-good.svg" @click="annotationMode('hand-good')">
          <img :class="currentMode === 'hand-bad' ? 'active' : ''" draggable="false" src="static/hand-bad.svg" @click="annotationMode('hand-bad')">
        </div>
      </div>
      <br />
      <div class="form-group">
        <input type="checkbox" id="showAnnotations" class="form-check-input" v-model="showAnnotations" @click="toggleShowAnnotations">
        <label for="showAnnotations">Show Annotations</label>
      </div>

      <hr /> -->

      <!-- <div id="editorSettings">
        <h4>Editor Settings</h4>
        <div class="form-group">
          <label for="fontFamily">Font Family</label>
          <select id="fontFamily" class="form-control">
            <option v-for="(font, index) in fonts" :key="index">
              {{ font.name }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="fontSize">Font Size</label>
          <input type="number" id="fontSize" class="form-control" min="1">
        </div>
        <div class="form-group">
          <input type="checkbox" id="reverseAutofill" class="form-check-input">
          <label for="reverseAutofill">Reverse Autofill</label>
        </div>
        <div class="form-group">
          <input type="checkbox" id="inlineHelp" class="form-check-input">
          <label for="inlineHelp">Enable Inline Help</label>
        </div>
      </div> -->

      <hr />

      <div id="templateSettings">
        <h4>Templates</h4>
        <label for="currentTemplate">Current Template:</label>
        <select id="currentTemplate" class="form-control form-control-sm" v-model="currentTemplateName" @change="changeTemplate">
          <option v-for="(template, index) in $store.state.templates" :key="index">
            {{ template.name }}
          </option>
        </select>
        <br />
        <button class="btn btn-light btn-sm btn-block" @click="showTemplateEditorDialog">Template Editor</button>
        <button class="btn btn-light btn-sm btn-block" @click="showTemplateDuplicateDialog">Duplicate Template</button>
        <button class="btn btn-light btn-sm btn-block" @click="showTemplateAddDialog">Add Empty Template</button>
        <button class="btn btn-light btn-sm btn-block" @click="showTemplateDeleteDialog">Delete Template</button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'side-menu-toolbox',

    beforeMount () {
      this.$store.commit('setShowAnnotationMenu', false)
      this.$store.commit('setDrawAnnotations', false)
    },

    mounted () {
      this.getTemplates()
      let that = this
      this.$bus.on('setCurrentTemplateName', function (templateName) {
        that.currentTemplateName = templateName
      })
    },

    data () {
      return {
        currentTemplateName: '',
        showAnnotations: true,
        currentMode: 'text',
        fonts: [
          { name: 'Arial', fallback: 'Helvetica', type: 'sans-serif' },
          { name: 'Arial Black', fallback: 'Gadget', type: 'sans-serif' },
          { name: 'Comic Sans MS', fallback: '', type: 'cursive' },
          { name: 'Impact', fallback: 'Charcoal', type: 'sans-serif' },
          { name: 'Lucida Sans Unicode', fallback: 'Lucida Grande', type: 'sans-serif' },
          { name: 'Tahoma', fallback: 'Geneva', type: 'sans-serif' },
          { name: 'Trebuchet MS', fallback: 'Helvetica', type: 'sans-serif' },
          { name: 'Verdana', fallback: 'Geneva', type: 'sans-serif' },
          { name: 'Georgia', fallback: '', type: 'serif' },
          { name: 'Palatino Linotype', fallback: 'Palatino', type: 'serif' },
          { name: 'Times New Roman', fallback: 'Times', type: 'serif' },
          { name: 'Lucida Console', fallback: '', type: 'monospace' },
          { name: 'Courier New', fallback: 'Courier', type: 'monospace' }
        ]
      }
    },

    methods: {
      changeTemplate () {
        this.$store.commit('setCurrentTemplateName', this.currentTemplateName)
        this.$bus.emit('setCurrentTemplateName', this.currentTemplateName)
        let that = this
        this.$store.dispatch('applyTemplate').then(function (result) {
          if (result) {
            that.$bus.emit('addNotification', {
              title: 'Applied Template',
              body: 'Template "' + that.currentTemplateName + '" applied successfully.',
              type: 'success'
            })
          } else {
            that.$bus.emit('addNotification', {
              title: 'Error Applying Template',
              body: 'An error occured while applying the template "' + that.currentTemplateName + '". Please review the data and try again.',
              type: 'error'
            })
          }
        })
      },

      getTemplates () {
        const apiUrl = this.$store.state.apiUrl
        this.axios.get(apiUrl + 'template/list/' + this.$store.state.currentFormId).then(response => {
          let templates = response.data
          this.$store.commit('setTemplates', {})
          templates.forEach(template => {
            this.$store.commit('addTemplate', {
              id: template.name,
              data: template
            })
          })

          this.$store.commit('setCurrentTemplateName', 'default')
          this.currentTemplateName = this.$store.state.currentTemplateName
          if (this.$store.state.templates[this.$store.state.currentTemplateName] === undefined) return
          this.$store.commit('setTotalPages', Object.keys(this.$store.state.templates[this.$store.state.currentTemplateName]['pages']).length)
          this.$store.commit('setShowFields', true)
          this.$store.commit('setTranslation')
          this.$store.commit('setFieldPage')
          this.$store.commit('setPropsFieldGroups')

          // SET MODELS FROM AUTOFILL DETAILS

          let autofillId = this.$store.state.autofillId

          if (autofillId === null) {
            const autofill = {
              formId: this.$store.state.currentFormId,
              templateId: this.$store.state.templates[this.$store.state.currentTemplateName]['_id'],
              name: 'global',
              caseTypeId: 0,
              createdAt: new Date(),
              updatedAt: new Date()
            }

            this.$store.dispatch('addAutofill', autofill).then(response => {
              let autofillId = response.data.autofillId

              this.$store.commit('setAutofillId', autofillId)
            })
          } else this.$store.commit('setModelsAutofillDetails')

          this.getTemplateQuestionnaires()
          this.$bus.emit('hidePageFields')
        })
      },

      getTemplateQuestionnaires () {
        let newQuestionnaires = {}
        const apiUrl = this.$store.state.apiUrl
        for (const templateIndex in this.$store.state.templates) {
          if (this.$store.state.templates.hasOwnProperty(templateIndex)) {
            const template = this.$store.state.templates[templateIndex]
            this.axios.get(apiUrl + 'questionnaire/list/' + template._id).then(response => {
              if (response.status !== 200) return
              if (!response.data.length) return
              newQuestionnaires[templateIndex] = response.data[0]
              this.$store.commit('setQuestionnaires', JSON.parse(JSON.stringify(newQuestionnaires)))
              this.$store.commit('setQuestionnairePageAndTabOrder')
              if (this.$store.state.templates[templateIndex].name === 'default') this.$bus.emit('reloadQuestionnaire')
            })
          }
        }
      },

      showTemplateAddDialog () {
        this.$store.commit('setShowAnnotationMenu', false)
        this.$store.commit('setDrawAnnotations', false)
        this.$store.commit('setShowBottomMenu', true)
        this.$bus.emit('hideControls')
        this.$bus.emit('showTemplateAddDialog')
      },

      showTemplateDuplicateDialog () {
        this.$store.commit('setShowAnnotationMenu', false)
        this.$store.commit('setDrawAnnotations', false)
        this.$store.commit('setShowBottomMenu', true)
        this.$bus.emit('hideControls')
        this.$bus.emit('showTemplateDuplicateDialog')
      },

      showTemplateDeleteDialog () {
        this.$store.commit('setShowAnnotationMenu', false)
        this.$store.commit('setDrawAnnotations', false)
        this.$store.commit('setShowBottomMenu', true)
        this.$bus.emit('hideControls')
        this.$bus.emit('showTemplateDeleteDialog')
      },

      showTemplateEditorDialog () {
        this.$store.commit('setShowAnnotationMenu', false)
        this.$store.commit('setDrawAnnotations', false)
        this.$store.commit('setShowBottomMenu', false)
        this.$bus.emit('hideControls')
        this.$bus.emit('showTemplateEditorDialog')
      },

      annotationMode (mode) {
        this.$bus.$emit('setAnnotationMode', mode)
        this.currentMode = mode
      },

      toggleShowAnnotationMenu () {
        if (this.$store.state.showAnnotationMenu) {
          this.$store.commit('setShowAnnotationMenu', false)
          this.$store.commit('setDrawAnnotations', false)
          this.$store.commit('setShowBottomMenu', true)
        } else {
          this.currentTemplateName = this.$store.state.currentTemplateName
          this.$store.commit('setShowAnnotationMenu', true)
          this.$store.commit('setDrawAnnotations', true)
          this.$store.commit('setShowBottomMenu', false)
          this.$bus.emit('hideControls')
          this.$bus.emit('closeModal')
        }
      },

      toggleShowAnnotations () {
        this.$store.commit('setShowAnnotations', !this.showAnnotations)
        this.$store.commit('setShowBottomMenu', this.showAnnotations)
      }
    },

    computed: {
      hideStyle: function () {
        return this.$store.state.showAnnotationMenu ? 'right:0;' : ''
      }
    },

    beforeDestroy () {
      this.$bus.$off('setCurrentTemplateName')
    }
  }
</script>

<style lang="scss" scoped>
  #menuContainer {
    width: 12%;
    height: 100%;
    position: fixed;
    top: 2vh;
    right: -179px;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 2;
    user-select: none;
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    -ms-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    transition: all 0.2s ease;
    width: 208px;
  }

  hr {
    border-top: 1px solid black;
    // margin: 0;
  }

  #toolboxGrabber {
    background-color: #eee;
    width: 10%;
    height: 60px;
    position: absolute;
    left: 0;
    top: 50%;
    border: 1px solid black;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    text-align: center;
    cursor: pointer;
    width: 30px;
    top: 43%;

    i {
      display: block;
      line-height: 60px;
      font-size: 150%;
    }
  }

  #backgroundWrapper {
    margin-left: 10%;
    width: 90%;
    height: 100%;
    background-color: #eeeeee;
    border-left: 1px solid black;
    padding: 10px;
    margin-left: 30px;
    width: 177px;
  }

  #annotationMenu {
    padding-top: 25%;

    h4 {
      text-decoration: underline;
      text-align: center;
    }

    .annotationButtons {
      padding-left: 5%;
    }

    img {
      width: 50px;
      height: auto;
      margin: 3px;
      cursor: pointer;

      &:hover {
        border: 2px solid black;
        padding: 2px;
      }

      &.active {
        border: 2px solid blue;
        padding: 2px;
      }
      color: red;
      fill: currentColor;
      stroke: currentColor;
    }
  }

  #editorSettings {
    margin-top: 25px;

    h4 {
      text-align: center;
      text-decoration: underline;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/editor/main/SideMenuToolbox.vue